/*
 * Bonvelle · bolletjes onder de productfoto's (30-10-2026). Hoort bij snippets/rh-fotobolletjes.liquid.
 *
 * Eén bolletje per zichtbare foto van Horizons galerij; het actieve krijgt .is-actief. Volgt het event
 * slideshow:select (vegen en kiezen) en tekent opnieuw als er foto's bij komen of verdwijnen, bijvoorbeeld bij een
 * andere variant (hide_variants). De galerij wordt elke keer opnieuw opgezocht, omdat Horizon hem bij een andere
 * variant kan vervangen. Minder dan twee foto's: geen bolletjes.
 */
(() => {
  if (customElements.get('rh-fotobolletjes')) return;

  class RhFotobolletjes extends HTMLElement {
    connectedCallback() {
      this.vak = this.parentElement;
      if (!this.vak) return;
      this.vak.addEventListener('slideshow:select', this.#bijKeuze);
      // Wat er in dit element zelf verandert, telt niet: anders tekent het zichzelf eindeloos opnieuw.
      this.waarnemer = new MutationObserver((records) => {
        if (records.some((record) => !this.contains(record.target))) this.#teken();
      });
      this.waarnemer.observe(this.vak, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });
      this.#teken();
    }

    disconnectedCallback() {
      this.vak?.removeEventListener('slideshow:select', this.#bijKeuze);
      this.waarnemer?.disconnect();
    }

    get #galerij() {
      return this.vak?.querySelector('media-gallery > slideshow-component');
    }

    #bijKeuze = (event) => {
      if (event.target !== this.#galerij) return;
      this.#teken(event.detail?.index);
    };

    #teken(index) {
      const galerij = this.#galerij;
      const aantal = galerij?.slides?.length ?? 0;
      const verbergen = aantal < 2;
      if (this.hidden !== verbergen) this.hidden = verbergen;
      if (verbergen) return;

      if (this.children.length !== aantal) {
        this.replaceChildren(...Array.from({ length: aantal }, () => document.createElement('i')));
      }
      const actief = index ?? galerij.current ?? 0;
      Array.from(this.children).forEach((bol, i) => bol.classList.toggle('is-actief', i === actief));
    }
  }

  customElements.define('rh-fotobolletjes', RhFotobolletjes);
})();
